// Product-supplied role-aware dashboard resolver (arch doc §4.5).
// Uses the verified useAuth() shape: isAuthenticated = !!user, plus derived isOwner/isAdmin.
// isAdmin is checked BEFORE isOwner because isOwner is true for ADMIN in this codebase.
export function resolveDashboardPath({ isAuthenticated, isAdmin, isOwner } = {}) {
  if (!isAuthenticated) return { path: '/', labelKey: 'experience.dashboard.home' };
  if (isAdmin) return { path: '/admin', labelKey: 'experience.dashboard.admin' };
  if (isOwner) return { path: '/owner/dashboard', labelKey: 'experience.dashboard.owner' };
  return { path: '/dashboard', labelKey: 'experience.dashboard.user' };
}
